<template>
    <div>
      <div class="banner">
        <div class="headerReplacementWarrantHoldersInfo"></div>
        <div class="banner-text">
          <b>{{ $t('warrantInfo.title') }}</b>
          <div class="breadcrumb">
            <span>
              <router-link to="/" class="pe-auto">{{ $t('warrantInfo.home') }}</router-link>
            </span>
            <span class="separator"></span>
            <span><b>{{ $t('warrantInfo.title') }}</b></span>
          </div>
        </div>
      </div>
  
      <div class="container">
        <table class="table mt-3 mb-5">
          <thead>
            <tr class="table-secondary text-center">
              <th style="width: 90%; font-size: clamp(12px, 1.5vw, 18px);" class="align-middle">
                <b>{{ $t('warrantInfo.title') }}</b>
              </th>
              <th style="width: 10%; font-size: clamp(12px, 1.2vw, 14px);" class="align-middle">
                ORI - W2
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in 4" :key="index">
              <th class="align-middle" style="font-weight: normal;">
                {{ $t(`warrantInfo.row${index + 1}`) }}
              </th>
              <td class="text-center align-middle">
                <a
                  v-if="downloadLinks[`row${index + 1}`][currentLang][5]"
                  :href="downloadLinks[`row${index + 1}`][currentLang][5]"
                  target="_blank"
                >
                  <i class="text-secondary fa-solid fa-download"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  
<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            downloadLinks: {
                row1: {
                    th: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1747971192099-terms-of-rights-TH.pdf"],
                    en: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750043652182-terms-of-rights-EN.pdf"],
                },
                row2: {
                    th: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1747971191410-Summary-of-information-TH.pdf"],
                    en: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750043708964-Summary-of-Information-Memorandum-EN.pdf"]
                },
                row3: {
                    th: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750056585014-Notiification-for-Exercise-Period-of-ORI-W1_Thai_No.1.pdf"],
                    en: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750056615301-Notiification-for-Exercise-Period-of-ORI-W2_Eng_No.1.pdf"],
                },
                row4: {
                    th: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750056722082-Notification-of-Intent-Form-TH.pdf"],
                    en: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1750056688312-Notification-of-Intent-Form-EN.pdf"]
                }
            }
        };
    },
    computed: {
        currentLang() {
            return this.$i18n.locale || 'th';
        }
    },
    methods: {}
};
</script>
  
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  

<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  